import FormControl from '@mui/material/FormControl/FormControl';
import MenuItem from '@mui/material/MenuItem/MenuItem';
import React, { useState, useEffect } from 'react';
import { TextField } from '@mui/material';
import styled from 'styled-components';
import NewCampaignDialog from '../../Modals/NewCampaignDialog';
import useFetch from '../../../utils/useFetch';

const StyledFormControl = styled(FormControl)`
  width: 100%;
`;

const CreateNewCampaign = styled.div`
  color: #27ab9e;
  margin: 1em 0 0em 0;
  cursor: pointer;
`;

export default function CampaignsInput({ value, currentName, onChange }) {
  const [update, setUpdate] = useState(null);
  const [campaigns, setCampaigns] = useState([]);
  // No status filter - show every non-archived, non-completed campaign
  // (draft/scheduled/active/paused), so a popup can be attached to one that
  // hasn't started yet. `assignable=true` excludes completed campaigns - those
  // are a terminal state (can't be restarted), so attaching a popup to one
  // would silently do nothing. `update` is passed last purely to retrigger this
  // fetch after creating a new campaign inline - the API method ignores it.
  const { loading, status, data } = useFetch('campaigns', null, true, update);

  useEffect(() => {
    setCampaigns((data?.campaigns || []).map((campaign) => ({ ...campaign, label: campaign.name, value: campaign.id })));
  }, [loading, status, data]);

  const handleCreated = (campaign) => {
    setUpdate(campaign);
    onChange(campaign.id);
  };

  return (
    <StyledFormControl variant="outlined">
      <TextField
        select
        value={value || ''}
        onChange={(event) => onChange(event.target.value)}
        size="small"
        SelectProps={{
          displayEmpty: true,
          // Without displayEmpty, MUI's Select renders nothing for an empty-
          // string value even when a matching MenuItem exists - it just looks
          // like a broken/blank field instead of a placeholder.
          renderValue: (selected) => {
            const match = selected && campaigns.find((item) => item.value === selected);
            if (match) return match.label;
            // Not in the assignable list (e.g. completed) - fall back to its real name.
            if (selected && currentName) return currentName;
            return <span style={{ color: '#9e9e9e' }}>Select Campaign</span>;
          },
        }}
      >
        <MenuItem value="">None</MenuItem>
        {campaigns.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </TextField>
      <NewCampaignDialog
        onSaved={handleCreated}
        button={(handleClickOpen) => (
          <CreateNewCampaign onClick={handleClickOpen}>Create new campaign</CreateNewCampaign>
        )}
      />
    </StyledFormControl>
  );
}
